// extracted by mini-css-extract-plugin
export default {"container":"OfferBanner_container__tCGja"};